import { set, map, findIndex, omit } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_PROJECT, SET_PROJECTS, SET_PROJECTS_STATUS } from 'vx/mutations'

const initialProjectState = () => {
    return {
      id: null,
      client_id: null,
      project_owner_id: null,
      project_type_id: null,
      title: "",
      start_date: "",
      end_date: "",
      milestones: []
    }
}

// User state.
const state = {
  project: initialProjectState(),
  projects: []
}

// User state getters.
const getters = {}

// User actions.
const actions = {

  getScopingProjects ({ commit }, payload) {
    return http.get(`/projects/statuses?${queryString(payload)}`).then(response => {
      commit(SET_PROJECTS, response.data)

      return response
    })
  },

  getProject ({ commit }, id) {
    return http.get(`/projects/${id}`).then(response => {
      commit(SET_PROJECT, response.data.data)

      return response
    })
  },

  updateProjectStatus ({ commit }, { id, payload }) {
    return http.put(`/projects/${id}/status`, payload)
  }
}

// User state mutations.
const mutations = {

  /**
  * Set the project state.
  */
  [SET_PROJECT] (state, project) {
    state.project = project
  },

  /**
  * Set the projects state.
  */
  [SET_PROJECTS] (state, projects) {
    state.projects = projects
  },

  /**
  * Set a projects status.
  */
  [SET_PROJECTS_STATUS] (state, { projectId, statusId }) {
    let existingIndex = findIndex(state.projects, existing => existing.id === projectId)

    if (existingIndex > -1) {
      // set(state.projects[existingIndex], 'project_status_id', statusId)
      state.projects[existingIndex].project_status_id = statusId
    }
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
